export default defineAppConfig({
  layout: {
    name: "CitizenM layout package",
  },
});

declare module "@nuxt/schema" {
  interface AppConfigInput {
    layout?: {
      /** Project name */
      name?: string;
    };
  }
}
